<template lang="pug">
div.nse-form-group
    div.label-show-mobile(v-if="!showLabel") {{ title }}

    div.wrap-flex
        label.label-form(:class="{'only-icon': !showLabel}")
            img.icon(:src="getIcon()")
            span.text(v-if="showLabel") {{ title }}
        div.input-form
            slot

        div.toggle-edit(v-if="editToggle")
            a-switch(:checked-children="LANG.EDIT" :un-checked-children="LANG.LOCK"  v-model:checked="editable")

</template>

<script>
export default {
    name: "GlobalWrapper",
    props: {
        title: {},
        fieldName: {
            type: String,
            default: ''
        },
        showLabel: {
            type: Boolean,
            default: true
        },

        editToggle:{
            type: Boolean,
            default: false
        }
    },
    watch: {
        editable(vl) {
            this.$emit('toggle_edit', vl)
        }
    },
    computed:{
        editable:{
            get() {
                return  this.store.value[`editable_${this.fieldName}`];
            },
            set(checked) {
                this.store.value[`editable_${this.fieldName}`] = checked;
            }

        }
    },
    methods: {
        getIcon() {
            return `${nse_config.assets_url}assets/image/icon/${this.fieldName}.svg`
        }
    }
}
</script>

<style lang="scss">
.nse-form-group {
    .wrap-flex {
        display: flex;
        align-items: start;
        align-content: center;
    }

    &.nse-input-error {
        .desc {
            color: red !important;
        }

        .input-form input[type=text],
        .input-form textarea {
            border-color: red !important;
        }
    }

    .label-show-mobile {
        font-weight: bold;
        margin-bottom: 15px;
    }

    + .nse-form-group {
        margin-top: 10px;
    }

    .label-form {
        width: 130px;
        min-width: 130px;
        max-width: 130px;
        font-weight: bold;
        font-size: 14px;
        display: flex;
        align-content: center;
        align-items: center;
        padding-top: 8px;
        @media (max-width: 991px) {
            padding-top: 3px;
        }
        &.only-icon {
            width: 30px;
            min-width: 30px;
            max-width: 30px;
        }

        .icon {
            width: 20px;
            height: 20px;
            object-fit: contain;
        }

        .text {
            padding-left: 5px;
        }
    }

    .toggle-edit {
        padding-top: 5px;
        padding-left: 10px;
        @media (max-width: 991px) {
            padding-top: 0px;
        }
    }

    .input-form {
        flex-grow: 1;

        input,
        input[type="date"],
        input[type="text"],
        input[type="time"],
        input[type="number"],
        textarea {
            border: none;
            border-bottom: 1px solid black;
            width: 100%;
            background-color: transparent;
            padding: 6px 0;
            border-radius: 0;
            font-size: 15px;

            @media (max-width: 991px) {
                padding-top: 2px;
            }
        }

        .desc {
            margin-top: 5px;
            font-size: 12px;
            color: #777;
        }
    }

    .slotInput {
        position: relative;

        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            margin: auto;
            -webkit-transition: all 0.25s;
            -moz-transition: all 0.25s;
            -ms-transition: all 0.25s;
            -o-transition: all 0.25s;
            transition: all 0.25s;
            width: 100%;
            height: 100%;
            opacity: 0;
            visibility: hidden;
        }

        &.disable-edit {
            &:after {
                background-color: #f9fafbd9;
                opacity: 1;
                visibility: visible;

                @media (max-width: 767px) {
                    background-color: #ffffffc8;
                }
            }
        }
    }
}

</style>
